import React from 'react';
import { RelanceAgendaSkeleton } from '../../features/relance/RelanceAgendaSkeleton';
import { RelanceForecastSkeleton } from '../../features/relance/RelanceForecastSkeleton';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';
import { SkeletonLine } from '../../ui/Skeleton/SkeletonLine';

// Mirrors the to-relance section — today's cards, the week's forecast, the ignored summary — so it settles without a jump.
export const HomeAgendaSkeleton: React.FC = () => (
    <div data-testid="home-agenda-skeleton" aria-hidden="true" className="flex flex-col gap-2xl">
        <div className="flex flex-col gap-m">
            <SkeletonLine lineClassName="text-block-title-emphasized" className="w-52" />
            <RelanceAgendaSkeleton rows={3} />
        </div>
        <div className="flex flex-col gap-xl">
            <SkeletonLine lineClassName="text-block-title-emphasized" className="w-60" />
            <RelanceForecastSkeleton />
        </div>
        <div className="flex items-center gap-s text-m">
            <div className="flex h-lh shrink-0 items-center"><SkeletonBar className="size-4" /></div>
            <SkeletonLine lineClassName="text-m" className="w-80 max-w-full" />
        </div>
    </div>
);
